<template>
  <div>
    <b-modal
      centered
      no-close-on-esc
      v-model="showModal"
      no-close-on-backdrop
      @hidden="onModalClose"
      modal-class="custom-width-modal"
    >
      <template #modal-title>
        <i class="mdi mdi-alert-outline me-2 font-size-16"></i>
        <span>Atenção</span>
      </template>

      <div class="">
        <div class="alert alert-warning mb-0" role="alert">
          <span>{{ mensagemInfo }}</span>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="fecharModal">
          <i class="mdi mdi-close me-1"></i>
          <span>Fechar</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalInfoFiltro",

  props: {
    isOpenModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showModal: false,
      mensagemInfo:
        "Para prosseguir, é necessário informar ao menos um critério de filtragem.",
    };
  },

  watch: {
    isOpenModal(value) {
      if (value) {
        this.showModal = true;
      }
    },
  },

  methods: {
    fecharModal() {
      this.showModal = false;
      this.$emit("update:isOpenModal", false);
    },

    onModalClose() {
      this.$emit("update:isOpenModal", false);
    },
  },
};
</script>

<style>
.custom-width-modal .modal-dialog {
  max-width: 600px !important;
  width: 600px !important;
}

.body-modal {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 600px) {
  .custom-width-modal .modal-dialog {
    max-width: 90% !important;
    width: 90% !important;
  }
}
</style>
